import { useCallback, useEffect, useState } from "react";
import axios from "../../../api/apiClient";
import { domain, token } from "../../Security";
import loadingSpinner from '../../../assets/loading.gif';

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { CreateTableNew as CreateTable } from "../../../common/APICommon";

export function ViewAllEventsEmployeeMemoForm({
  isOpen,
  onClose,
  editHandleClick,
  deleteHandleClick,
  isUpdate,
  setIsUpdate,
  userAccess
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);

  const isHR = userAccess && (
    userAccess.description === "Admin" ||
    userAccess.description === "HR Head" ||
    userAccess.description === "HR Assistant" ||
    userAccess.description === "HR Assistant2" ||
    userAccess.description === "HR Assistant3"
  );

  // ─── Headers / accessors ──────────────────────────────────────────────────
  const baseHeaders =  ["Employee ID", "Employee Name", "Memo Type", "Date From", "Date To", "Content", "Image", "Is Active?"];
  const baseAccessors = ["employeeId", "employeeFullName", "memoTypeName", "dateFrom", "dateTo", "description", "content", "isActive"];

  const headers =  isHR ? [...baseHeaders,  "Actions"] : baseHeaders;
  const accessors = isHR ? [...baseAccessors, "actions"]  : baseAccessors;
  // ──────────────────────────────────────────────────────────────────────────

  // ─── Actions (HR only) ────────────────────────────────────────────────────
  const actions = isHR ? [
    {
      name: "Edit",
      tooltip: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
    {
      name: "Delete",
      tooltip: "Delete",
      icon: <DeleteIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600 flex items-center",
      function: deleteHandleClick,
      visible: true,
    },
  ] : [];
  // ──────────────────────────────────────────────────────────────────────────

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/EmployeeMemo";
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setRequests(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
      setIsUpdate(false);
    }
  }, [setIsUpdate]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen, isUpdate]);

  const handleClose = () => {
    setRequests([]);
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>All Employee Memos</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div className="users-table container" style={{ overflow: "unset" }}>
                {loading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                    <img src={loadingSpinner} alt="Loading..." />
                  </div>
                ) : (
                  <CreateTable
                    tableName="EmployeeMemo"
                    headers={headers}
                    accessors={accessors}
                    data={requests}
                    actions={actions}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={10}
                    totalItems={requests.length}
                  />
                )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
    </>
  );
}